import { httpRequest } from "@/utils/HttpRequest";
import { IPage } from "@/types/AppTypes";
import { ISCMAssetsEntrySearch, ISCMAssetsEntryDetail, ISCMAssetsEntryStatistics, ISCMAssetsEntryInsert, ISCMAssetsEntryUpdate, ISCMSDcGoodsOne, ISCMSDcSearch, ISCMORVRMTransferSearch, ISCMORVRMTransferDetails } from "./assetsEntryTypes";


export interface ISCMPage<T, S> extends IPage<T> {
    statistics: S
}
export interface IAssetsDetail {
    [key:string]:any
}
export interface IAssetsDetailSearchFields  {
    [key:string]:any
}

export interface IFmsShopUnitDetail {
    address: string,
    bentity: string,
    branch: string,
    branchList: string,
    code: string,
    contact: string,
    createTime: string,
    createUser: string,
    deleteFlag: string,
    enable: string,
    id: string,
    name: string,
    note: string,
    phone: string,
    shop: string,
    shopCode: string,
    shopList: string,
    shopName: string,
    status: string,
    tel: string,
    updateTime: string,
    updateUser: string,
    ver: string,
}

class AssetsEntryService {
    async page(searchVo: ISCMAssetsEntrySearch) {
        const apiUrl = "/assets/assets/page";
        return await httpRequest.post<IPage<ISCMAssetsEntryDetail>>(apiUrl, searchVo);
    }
    async pageStatistics(searchVo: ISCMAssetsEntrySearch) {
        const apiUrl = "/assets/assets/total";
        return await httpRequest.post<ISCMAssetsEntryStatistics>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/assets/assets/findById/${id}`
        return await httpRequest.get<ISCMAssetsEntryDetail>(apiUrl)
    }
    async insert(insertVo: ISCMAssetsEntryInsert) {
        const apiUrl = '/assets/assets/insert'
        return await httpRequest.post<boolean>(apiUrl, insertVo)
    }
    async update(updateVo: ISCMAssetsEntryInsert) {
        const apiUrl = '/assets/assets/update'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    async deleteImg(updateVo: any) {
        const apiUrl = '/assets/base/material/updateMaterialPhoto'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    async export(searchVo: ISCMAssetsEntrySearch) {
        const apiUrl = "/assets/assets/export";
        return await httpRequest.postFile<boolean>(apiUrl, searchVo, { timeout: 300000 });
    }

    async print(id: string) {
        const apiUrl = `/assets/assets/print/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //主表标签
    async printTip(id: string) {
        const apiUrl = `/assets/assets/printLabelTwo/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }

    //商品标签打印
    async printGoodTip(value: any) {
        const apiUrl = '/assets/assets/printLabelTwoList'
        return await httpRequest.post<boolean>(apiUrl, value)
    }
    async insertAssets(insertVo: any) {
        const apiUrl = '/assets/base/material/insert'
        return await httpRequest.post<ISCMAssetsEntryDetail[]>(apiUrl, insertVo)
    }
    //资产明细查询接口
    async assetsListDetails(searchVo: ISCMORVRMTransferSearch) {
        const apiUrl = "/assets/assets/detailsPage";
        return await httpRequest.post<IPage<ISCMORVRMTransferDetails>>(apiUrl, searchVo);
    }
    //下载模板
    async downloadTpl() {
        const apiUrl = "/assets/assets/downloadTpl";
        return await httpRequest.getFile<boolean>(apiUrl);
    }
}

export const assetsEntryService = new AssetsEntryService();
